import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import cls from './stepped-content.module.scss'
import { Grid } from '@/shared/ui/Grid/Grid'
import { Text } from '@/shared/ui/Text/Text'

export const SteppedContent = props => {
  const { activeStepIndex, children, steps, onStepClick, style, className, hideStepsIndicator } =
    props

  const stepContent = useMemo(() => {
    const childrenArray = React.Children.toArray(children)
    return childrenArray[activeStepIndex] || null
  }, [children, activeStepIndex])

  return (
    <>
      <Grid style={style} container direction="column" alignItems="center">
        {stepContent}
      </Grid>
      {!hideStepsIndicator ? (
        <StepsIndicator
          activeStepIndex={activeStepIndex}
          onStepClick={onStepClick}
          className={classNames(cls.stepper, className)}
          labels={steps}
        />
      ) : null}
    </>
  )
}

SteppedContent.propTypes = {
  activeStepIndex: PropTypes.number.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  onStepClick: PropTypes.func,
  steps: PropTypes.array,
  style: PropTypes.object,
  hideStepsIndicator: PropTypes.bool,
}

const StepsIndicator = props => {
  const { className, labels, activeStepIndex, onStepClick } = props

  return (
    <Grid className={className} container direction="row" alignItems="center">
      {labels.map((label, index) => (
        <Step
          onClick={() => onStepClick(index)}
          key={index}
          state={
            index < activeStepIndex ? 'completed' : activeStepIndex === index ? 'active' : undefined
          }
          isFirst={index === 0}
          index={index + 1}
        />
      ))}
    </Grid>
  )
}

const Step = props => {
  const { classes = {}, key, state, isFirst, index } = props

  return (
    <>
      {!isFirst && <div className={classNames(cls.line, classes.line)} />}
      <Grid
        key={key}
        className={classNames(cls.step, { [cls.stepActive]: state === 'active' }, classes.step)}
        container
        justify="center"
        alignItems="center"
      >
        <Text className={classes.text}>{index}</Text>
      </Grid>
    </>
  )
}
